import { makeObservable, observable } from 'mobx'
import * as R from 'ramda'

import { sortBy, groupBy } from '../../../utils/helpers'
import Licence from './model/Licence'

class LicenceManagerStore {
    productStatuses = [
        {
            value: 1,
            label: 'Created',
        },
        {
            value: 2,
            label: 'Active',
        },
        {
            value: 3,
            label: 'Archived',
        },
        {
            value: 4,
            label: 'Deleted',
        },
        {
            value: 5,
            label: 'Template',
        },
        {
            value: 6,
            label: 'Licence Exempt',
        },
    ]

    @observable clients = []

    licences

    industries = []

    productMap = {}

    @observable totalLicences = 0

    @observable clientId

    constructor(store) {
        makeObservable(this)
        this.store = store
        this.productStatusMap = this.productStatuses.reduce((a, { value, label }) => (
            Object.assign(a, { [value]: label })
        ), {})
    }

    getProductMap = async (clientId) => {
        const productMaps = await this.store.http.get(`/productmap/${clientId}?showAllLinked=true`)

        const productMap = productMaps.reduce((
            productMap,
            {
                producttypecode,
                productTypeNameOnly,
                industrycode,
                industryname,
            },
        ) => {
            if (!R.has(industrycode, productMap)) {
                productMap[industrycode] = {
                    name: industryname,
                    productTypes: [],
                }
            }

            productMap[industrycode].productTypes[producttypecode] = productTypeNameOnly

            return productMap
        }, {})
        console.log('productMap', productMap)
        this.productMap = productMap
    }

    init = async () => {
        await Promise.all([
            this.getClients(),
        ])
    }

    getProductTypeLabel = (industry, productType) => (
        this.productMap[industry].productTypes[productType]
    )

    getProductStatusLabel = (status) => this.productStatusMap[status]

    getClients = async () => {
        const { store } = this
        const { clientId } = store.userData
        let clients = []
        try {
            if (clientId === 1) {
                const response = await store.http.get('/client')
                clients = response.clients
            } else {
                const response = await store.http.get(`/client/${clientId}`)
                clients = [{
                    clientId,
                    name: response.name,
                }]
            }
        } catch (e) {
            console.error(e)
            store.handleError({ body: 'Error loading clients', level: 'error' })
        }

        this.clients = sortBy(clients, 'name')
            .map(({ clientId, name }) => ({
                value: clientId,
                label: `[${clientId}] - ${name}`,
            }))
    }

    getLicence = (productType) => {
        const { licences } = this
        let licence = new Licence({
            licenceCount: 0,
            productType,
        })

        if (R.has(productType, licences)) {
            licence = licences[productType][0]
        }

        return licence
    }

    getLicences = async (clientId) => {
        const licences = await this.store.http.get(`/intranet/licence/client/${clientId}`)
        this.totalLicences = licences.reduce((a, { licenceCount }) => (a + licenceCount), 0)
        this.licences = groupBy(licences.map((licence) => new Licence(licence)), 'productType')
    }

    saveProduct = async (product) => {
        const { productId } = product
        await this.store.http.put(`/intranet/licence/product/${productId}`, JSON.stringify(product))
    }

    saveLicence = async (licence) => {
        await this.store.http.put(`/intranet/licence/client/${this.clientId}`, JSON.stringify(licence))
        this.totalLicences = Object.entries(this.licences)
            .reduce((total, [productType, licences]) => (
                licences.reduce((a, { licenceCount }) => a + licenceCount, total)
            ), 0)
    }
}

export default LicenceManagerStore
